export const COLUMNS_ENUM = Object.freeze({
  MY_ASN: { order: 0, name: "Configured AS" },
  NEIGHBOR_ASN: { order: 1, name: "Neighbor AS" },
  DATA_SOURCES_NUMBER: { order: 2, name: "Data Sources (#)" },
  DATA_SOURCES_PERCENTAGE: { order: 3, name: "Data Sources (%)" },
});
